import { Button, ICON_SIZE_MAP } from "../components/Button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger, } from "../components/Dropdown";
import { Icon } from "../components/Icon";
import { ChevronRightIcon } from "../icons/app";
import { cn } from "../lib";
import { cva } from "class-variance-authority";
import React from "react";
const DEFAULT_LABEL_TRUNCATE_LENGTH_MIDDLE = 15;
const DEFAULT_LABEL_TRUNCATE_LENGTH_END = 30;
const ELLIPSIS_STRING = "...";
const breadcrumbTextVariants = cva("", {
    variants: {
        isLast: {
            true: "s-text-foreground dark:s-text-foreground-night",
            false: "s-text-muted-foreground dark:s-text-muted-foreground-night",
        },
        size: {
            xs: "",
            sm: "",
        },
        hasLighterFont: {
            true: "",
            false: "",
        },
    },
    compoundVariants: [
        { size: "xs", hasLighterFont: true, className: "s-text-xs" },
        { size: "sm", hasLighterFont: true, className: "s-text-sm" },
        { size: "xs", hasLighterFont: false, className: "s-label-xs" },
        { size: "sm", hasLighterFont: false, className: "s-label-sm" },
    ],
    defaultVariants: {
        size: "sm",
        hasLighterFont: true,
        isLast: false,
    },
});
const isLinkItem = (item) => "href" in item && typeof item.href === "string";
const isButtonItem = (item) => "onClick" in item && typeof item.onClick === "function";
function BreadcrumbItem({ item, isLast, itemsHidden, size = "sm", hasLighterFont = true, truncateLengthMiddle = DEFAULT_LABEL_TRUNCATE_LENGTH_MIDDLE, truncateLengthEnd = DEFAULT_LABEL_TRUNCATE_LENGTH_END, }) {
    if (item.label === ELLIPSIS_STRING) {
        return (React.createElement(DropdownMenu, null,
            React.createElement(DropdownMenuTrigger, { asChild: true },
                React.createElement(Button, { variant: "ghost", label: ELLIPSIS_STRING, icon: item.icon, size: size, hasLighterFont: hasLighterFont })),
            React.createElement(DropdownMenuContent, { align: "start" },
                React.createElement(DropdownMenuGroup, null, itemsHidden === null || itemsHidden === void 0 ? void 0 : itemsHidden.map((item, index) => (React.createElement(DropdownMenuItem, { key: `breadcrumbs-hidden-${index}`, href: isLinkItem(item) ? item.href : undefined, onClick: isButtonItem(item) ? item.onClick : undefined, icon: item.icon, label: item.label })))))));
    }
    const textClassName = breadcrumbTextVariants({
        isLast,
        size,
        hasLighterFont,
    });
    const truncatedLabel = truncateTextToLength(item.label, isLast ? truncateLengthEnd : truncateLengthMiddle);
    const isLabelTruncated = truncatedLabel !== item.label;
    if (isLinkItem(item)) {
        return (React.createElement(Button, { href: item.href, icon: item.icon, variant: isLast ? "ghost" : "ghost-secondary", label: truncatedLabel, tooltip: isLabelTruncated ? item.label : undefined, size: size, hasLighterFont: hasLighterFont }));
    }
    if (isButtonItem(item)) {
        return (React.createElement(Button, { onClick: item.onClick, icon: item.icon, variant: isLast ? "ghost" : "ghost-secondary", label: truncatedLabel, tooltip: isLabelTruncated ? item.label : undefined, size: size, hasLighterFont: hasLighterFont }));
    }
    if (item.icon) {
        return (React.createElement("div", { className: "s-shrink0 s-label-sm s-inline-flex s-h-9 s-items-center s-gap-2 s-border s-border-border/0 s-px-3" },
            React.createElement(Icon, { visual: item.icon, size: ICON_SIZE_MAP[size], className: cn("-s-mx-0.5") }),
            React.createElement("div", { className: textClassName }, item.label)));
    }
    return (React.createElement("div", { className: cn("s-px-2 s-py-1.5", textClassName) }, item.label));
}
export function Breadcrumbs({ items, className, size = "sm", hasLighterFont = true, truncateLengthMiddle, truncateLengthEnd, }) {
    const { itemsShown, itemsHidden } = items.reduce((acc, item, index) => {
        if (items.length <= 5 || index < 2 || index >= items.length - 2) {
            acc.itemsShown.push(item);
        }
        else if (index === 2) {
            acc.itemsShown.push({ label: ELLIPSIS_STRING });
            acc.itemsHidden.push(item);
        }
        else {
            acc.itemsHidden.push(item);
        }
        return acc;
    }, { itemsShown: [], itemsHidden: [] });
    return (React.createElement("div", { className: cn("s-flex s-flex-row s-items-center s-gap-0", className) }, itemsShown.map((item, index) => {
        return (React.createElement("div", { key: `breadcrumbs-${index}`, className: "s-flex s-flex-row s-items-center s-gap-0" },
            React.createElement(BreadcrumbItem, { item: item, isLast: index === itemsShown.length - 1, itemsHidden: itemsHidden, size: size, hasLighterFont: hasLighterFont, truncateLengthMiddle: truncateLengthMiddle, truncateLengthEnd: truncateLengthEnd }),
            index === itemsShown.length - 1 ? null : (React.createElement(Icon, { visual: ChevronRightIcon, className: "s-text-faint", size: size === "xs" ? "xs" : "sm" }))));
    })));
}
function truncateTextToLength(text, length) {
    return text.length > length
        ? `${text.substring(0, length - 1)}${ELLIPSIS_STRING}`
        : text;
}
//# sourceMappingURL=Breadcrumbs.js.map